import { OffTopicIcon, ProfilePicture, TechDiffIcon } from "assets/images";
import React from "react";
import "./payout.css";
import { convertUTCToLocalMyPayoutsFormat } from "utils/dateFormatter";
import PurebrandLoader from "components/Loader/PurebrandLoader";
import CustomModal from "components/Modal/CustomModal";
import AuthContext from "context/AuthContext";
import PaymentContext from "context/PaymentContext";
import { OverlayTrigger, Popover, Tooltip } from "react-bootstrap";
import { utcLocalTimeStringConversion } from "utils/dateFormatter";
import { calculateVideoDuration, convertUTCToLocal } from 'utils/dateFormatter';
import { Icon, guestNoShow, success, backupSuccess, saleCanceled, saleFulfilled, salePending } from 'assets/images';
import { DEMO_HISTORY_STATUS } from 'utils/constants';
import moment from "moment";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faHourglassHalf } from '@fortawesome/free-solid-svg-icons';
import { HAS_DISCUSSED_BUSINESS } from "utils/constants";
import { getRewardTypeLabel } from 'components/Forms/Multistep/constants';
const PayoutAccepted = (props) => {
  const { hostDetails, filters, ...rest } = props;
  const commission = props?.filters?.commissionFilter || null; // Commission filter
  const statusFilter = props?.filters?.statusFilter || null; // Status filter
  const startDateFilter = props?.filters?.startDate || null; // The start date filter
  const endDateFilter = props?.filters?.endDate || null; // The end date filter
  const FailedStatus = [
    "card_declined",
    "payment_blocked",
    "expired_card",
    "error_creating_intent",
    "payout_failed",
    "failed"
  ];

  /**
   * List of extra guest sales earnings associated with the host.
   * Extra guests earn sales commission independently of the primary guest.
   *
   * @type {Array<Object>}
   */
  const extraGuestSalesEarnings = hostDetails?.extra_guest_earnings || [];


  /**
   * Maps an extra guest sale object into a normalized earning structure.
   *
   *
   * @param {Object} extraSale - Extra guest sale record
   * @returns {Object} Normalized earning object for payment/status handling
   */
  const mapExtraSaleToEarning = (extraSale) => ({
    sales_commission: extraSale?.sales_commission,
    sales_commission_paid: extraSale?.sales_commission_paid,
    sales_commission_fulfilled_date: extraSale?.sales_commission_fulfilled_date,
    sales_commission_cancellation_date: extraSale?.sales_commission_cancellation_date,
    stripe_sales_payment_status: extraSale?.stripe_sales_payment_status,
    dots_sales_payment_status: extraSale?.dots_sales_payment_status,

    // IMPORTANT: extra guests do NOT have obtained date
    // sales_commission_obtained_date is the earned date
    sales_commission_obtained_date: extraSale?.sales_commission_obtained_date,
  });
  
  const getDemoResult = (
    guestAttended,
    scheduledAt,
    startedAt,
    endedAt,
    fallback_hosts_notified,
    salesCommissionData // Add sales commission data as parameter
  ) => {
    // Check for sales commission status
    if (salesCommissionData) {
      const { sales_commission_obtained_date, sales_commission_fulfilled_date, sales_commission_cancelled_date } = salesCommissionData;
  
      if (sales_commission_fulfilled_date) {
        
        return (<div style={{display:'flex', alignContent:'space-around'}}><img src={saleFulfilled} alt="Sale Fulfilled" /> Sale Fulfilled</div>);
      }
  
      if (sales_commission_cancelled_date) {
        return (<div style={{display: 'flex', alignContent:"space-around"}}>
          <img src={saleCanceled} alt="Sale Canceled" />
        Sale Canceled
        </div>
      );
      }
  
      if (sales_commission_obtained_date && !sales_commission_fulfilled_date && !sales_commission_cancelled_date) {
        return(
          <div style={{display:'flex', alignContent:'space-around'}}>
          <img src={salePending} alt="Sale Pending" /> Sale Pending</div>)
      }
    }
  
    // Demo-specific status checks (retain existing logic for demo)
    if (scheduledAt && endedAt) {
          const endedDate = new Date(endedAt);
          const startedDate = startedAt
            ? new Date(startedAt)
            : new Date(scheduledAt);
          const scheduledDate = new Date(scheduledAt);
    
          let timeDifference;
    
          if (startedDate < scheduledDate) {
            timeDifference = Math.abs(endedDate - scheduledDate);
          } else {
            timeDifference = Math.abs(endedDate - startedDate);
          }
    
          if (!guestAttended) {
            if (timeDifference > 600000) {
              return (
                <>
                  <img src={guestNoShow} alt='Guest No Show' />{" "}
                  {DEMO_HISTORY_STATUS.GUEST_NO_SHOW}
                </>
              );
            } else {
              return (
                <>
                  <img src={guestNoShow} alt='Under Time' />{" "}
                  {DEMO_HISTORY_STATUS.UNDER_TIME}
                </>
              );
            }
          }
  
      if (fallback_hosts_notified) {
        return (
          <>
            <img src={backupSuccess} alt="Back Up Success" />
            {DEMO_HISTORY_STATUS.BACKUP_SUCCESS}
          </>
        );
      }
  
      return (
        <>
          <img src={success} alt="Success" />
          {DEMO_HISTORY_STATUS.SUCCESS}
        </>
      );
    }
  
    return '-';
  };
  const getPaymentStatus = (earning, type) => {
    if ("demo"=== type && earning?.earning_paid !== null) {
      return 'Paid';
    }
    if ("sale" === type && earning?.sales_commission_paid !== null) {
      return 'Paid';
    }

    if (
      (FailedStatus.includes(earning?.stripe_payment_status) ||
      FailedStatus.includes(earning?.dots_payment_status)) && type === "demo"
    ) {
      return 'Failed';
    }
    if (type === "sale" && (FailedStatus.includes(earning?.stripe_sales_payment_status) || FailedStatus.includes(earning?.dots_sales_payment_status))) {
      return 'Failed';
    }

    return 'Unpaid';
  };
// New status filtering logic
const matchesStatusFilter = (statusFilter, earning, type) => {
  if (!statusFilter) return true; // If no status filter, show all
  
  const currentStatus = getPaymentStatus(earning, type);
  return currentStatus.toLowerCase() === statusFilter.toLowerCase();
};
  const shouldDisplayDemoRow = commission?.toLowerCase() === 'demo' || commission?.toLowerCase() === 'no-show';
  const shouldDisplayBothRow = commission?.toLowerCase() !== 'demo' && commission?.toLowerCase() !== 'sales' && commission?.toLowerCase() !== 'no-show';
 // Check Sales Commission Value
const isSalesCommissionValid = hostDetails?.earning?.sales_commission !== '0.00';

// Render Sales Row Conditionally
const shouldDisplaySalesRow = commission?.toLowerCase() === 'sales' && isSalesCommissionValid;

const CalculateDate = (dateObject, type) => {
  if (type === 'sale earned') {
    if (dateObject?.sales_commission_cancellation_date) {
      return 'NA';
    
    } else if (dateObject?.sales_commission_obtained_date) {
      return utcLocalTimeStringConversion(
        dateObject?.sales_commission_obtained_date
      ) !== "Invalid date"
        ? utcLocalTimeStringConversion(
            dateObject?.sales_commission_obtained_date
          )
        : "-";
    } else {
      return "Pending";
    }
  }else if(type === "demo earned"){
    return (utcLocalTimeStringConversion(dateObject?.ended_at) !=="Invalid date"? utcLocalTimeStringConversion(dateObject?.ended_at): "NA");
  }
  else if(type === "demo date"){
    return (utcLocalTimeStringConversion(dateObject?.scheduled_date)!=="Invalid date"? utcLocalTimeStringConversion(dateObject?.scheduled_date): "NA");
  }else if (type === "demo paid"){
    return (dateObject?.earning <= 0 ? "NA": utcLocalTimeStringConversion(dateObject?.earning_paid)!=="Invalid date"? utcLocalTimeStringConversion(dateObject?.earning_paid): "Pending");
  }else if(type === "sale paid"){

      if (dateObject?.sales_commission_cancellation_date || FailedStatus.includes(dateObject?.stripe_payment_status) || FailedStatus.includes(dateObject?.dots_payment_status)) {
        return "NA";
      } else if (dateObject?.sales_commission_paid) {
        return utcLocalTimeStringConversion(
          dateObject?.sales_commission_paid
        ) !== "Invalid date"
          ? utcLocalTimeStringConversion(dateObject?.sales_commission_paid)
          : "-";
      } else {
        return "Pending";
      }
  }else{
    console.log("Could not calculate the date:", type, dateObject);
    return "NA";
  }

};
const matchesDateFilter = (startDate) => {
  if(!startDateFilter && !endDateFilter ) return true;
  const startDateFormatted = moment(startDate).format('YYYY-MM-DD')
  
  return startDateFormatted >= startDateFilter && startDateFormatted <= endDateFilter;

}

  const demoResult = (dataList, schedule, type = 'demo') => {
    if (dataList?.is_obscene_content) {
      return (
        <>
          <FontAwesomeIcon icon={faBan} style={{ color: "#dc3545", marginRight: 4 }} />
          {DEMO_HISTORY_STATUS.OBSCENE_CONTENT}
        </>
      );
    }
    const discussionStatus = dataList?.has_discussed_business_status;

    const primaryJoined = dataList?.members?.[0]?.guest_detail?.attend_meeting;

    const extraJoined = dataList?.members?.[0]?.extra_guests?.some(
      g => g?.guest_detail?.attend_meeting
    );
  
    const anyGuestJoined = primaryJoined || extraJoined;
  
    // Handle business discussion statuses (for 'demo' only)
    if (type === 'demo' && discussionStatus !== HAS_DISCUSSED_BUSINESS.NA) {
      if (discussionStatus === HAS_DISCUSSED_BUSINESS.NI || discussionStatus === HAS_DISCUSSED_BUSINESS.IP) {
        return (
          <div style={{ display: "flex", alignItems: "center", marginLeft: "3px" }}>
            <FontAwesomeIcon
              icon={faHourglassHalf}
              style={{ color: "#FFD43B", paddingRight: 4, marginRight: 4 }}
            />
            {DEMO_HISTORY_STATUS.PROCESSING}
          </div>
        );
      }
  
      if (discussionStatus === HAS_DISCUSSED_BUSINESS.FIN) {
        if (dataList?.has_discussed_business === true) {
          if (dataList?.fallback_hosts_notified) {
            return (
              <><img src={backupSuccess} alt="Back-Up Success" /> {DEMO_HISTORY_STATUS.BACKUP_SUCCESS}
              </>
            );
          }
          return (
            <>
              <img src={success} alt="Success" /> {DEMO_HISTORY_STATUS.SUCCESS}
            </>
          );
        } else if (dataList?.technical_difficulties) {
          return (
            <>
              <img
                src={TechDiffIcon}
                alt="TECH DIFF"
                style={{ width: '20px', height: '20px' }}
              />{" "}
              {DEMO_HISTORY_STATUS.TECH_DIFF}
            </>
          );
        } else {
          return (
            <>
              <img
                src={OffTopicIcon}
                alt="OFF TOPIC"
                style={{ width: "20px", height: "20px" }}
              />{" "}
              {DEMO_HISTORY_STATUS.OFF_TOPIC}
            </>
          );
        }
      }
  
      return null; // If status is not matched above
    }
  
    // Use getDemoResult logic for 'sales' and fallback 'demo'
    return getDemoResult(
      anyGuestJoined,  
        `${schedule?.scheduled_date}T${schedule?.scheduled_time}Z`,
      dataList?.started_at,
      dataList?.ended_at,
      dataList?.fallback_hosts_notified,
      type === 'sales'
        ? {
            sales_commission_obtained_date: dataList?.earning?.sales_commission_obtained_date,
            sales_commission_fulfilled_date: dataList?.earning?.sales_commission_fulfilled_date,
            sales_commission_cancelled_date: dataList?.earning?.sales_commission_cancellation_date,
          }
        : dataList?.status,
      dataList?.absent_host_details
    );
  };


  return (
    <>
      {/* {loading && <PurebrandLoader />} */}

      {/* Demo Commission Row */}
      {(shouldDisplayBothRow || shouldDisplayDemoRow) &&matchesStatusFilter(statusFilter, hostDetails?.earning, "demo") && matchesDateFilter(props?.hostDetails?.ended_at) && (
        <tr className="payout-table-items">
          <td><p>{hostDetails?.product?.store?.name}</p></td>
          <td><p>{hostDetails?.product?.name}</p></td>
          <td><p><strong>${hostDetails?.earning?.earning}</strong></p></td>
          <td><p>{getPaymentStatus(hostDetails?.earning, "demo")}</p></td>
          <td><p>Video meeting</p></td>
          <td><p>{demoResult(hostDetails, hostDetails?.schedule, 'demo')}
          </p></td>
          <td><p>{calculateVideoDuration(
              hostDetails?.started_at,
              hostDetails?.ended_at,
              hostDetails?.members[0]?.guest_detail?.attend_meeting,
              hostDetails?.members[0]?.guest_detail?.left_meeting,
              `${hostDetails?.schedule?.scheduled_date}T${hostDetails?.schedule?.scheduled_time}`
            )}
          </p></td>
          <td onClick={(e) => e.stopPropagation()}><p>
            {/* Primary guest */}
            {hostDetails?.members?.[0]?.guest_detail?.full_name || "-"}

            {/* Extra guest tooltip */}
            {hostDetails?.members?.[0]?.extra_guests?.length > 0 && (
              <OverlayTrigger
                placement="right"
                overlay={
                  <Tooltip id="tooltip-extra-guests-host" className="extra-guest-tooltip">
                    {hostDetails.members[0].extra_guests.map((g, i) => (
                      <div key={i}>{g?.guest_detail?.full_name}</div>
                    ))}
                  </Tooltip>
                }
              >
                <span
                  style={{
                    marginLeft: 6,
                    color: "#0d6efd",
                    cursor: "pointer",
                    fontSize: "13px",
                    fontWeight: 500,
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  +{hostDetails?.members?.[0]?.extra_guests?.length}
                </span>
              </OverlayTrigger>
            )}</p>
          </td>
          <td><p>{CalculateDate(hostDetails, "demo earned")}</p></td>
          <td><p>{CalculateDate(hostDetails?.schedule, "demo date")}</p></td>
          <td><p>{CalculateDate(hostDetails?.earning, "demo paid")}</p></td>
          <td><p>{getRewardTypeLabel(hostDetails?.host_reward_type)}</p></td>
        </tr>
      )}

      {/* Sales Commission Row */}
{(shouldDisplayBothRow || shouldDisplaySalesRow) && isSalesCommissionValid &&matchesStatusFilter(statusFilter, hostDetails?.earning, "sale") && matchesDateFilter(props?.hostDetails?.earning?.sales_commission_obtained_date)&&(
  <tr className="payout-table-items">
    <td><p>{hostDetails?.product?.store?.name}</p></td>
    <td><p>{hostDetails?.product?.name}</p></td>
    <td><p><strong>{(props?.hostDetails?.earning?.sales_commission_obtained_date && !props?.hostDetails?.earning?.sales_commission_fulfilled_date && !props?.hostDetails?.earning?.sales_commission_cancellation_date) ? "TBD" :`$${hostDetails?.earning?.sales_commission}`}</strong></p></td>
    <td><p>{getPaymentStatus(hostDetails?.earning, "sale")}</p></td>
    <td><p>Sales</p></td>
    <td className='table-result'><p>{demoResult( hostDetails, hostDetails?.schedule, 'sales')}</p></td>
    <td>
      <p>
        {calculateVideoDuration(
          hostDetails?.started_at,
          hostDetails?.ended_at,
          hostDetails?.members[0]?.guest_detail?.attend_meeting,
          hostDetails?.members[0]?.guest_detail?.left_meeting,
          `${hostDetails?.schedule?.scheduled_date}T${hostDetails?.schedule?.scheduled_time}`
        )}
      </p>
    </td>
    <td onClick={(e) => e.stopPropagation()}>
      {/* Primary guest */}
      <p>{hostDetails?.members?.[0]?.guest_detail?.full_name || "-"}</p>
    </td>

    <td><p>{CalculateDate(hostDetails?.earning, "sale earned")}</p></td>
    <td><p>{CalculateDate(hostDetails?.schedule, "demo date")}</p></td>
    <td><p>{CalculateDate(hostDetails?.earning, "sale paid")}</p></td>
    <td><p>{getRewardTypeLabel(hostDetails?.host_reward_type)}</p></td>
  </tr>
)}

{/* Extra Guests Sales Commission Rows */}
{(shouldDisplayBothRow || shouldDisplaySalesRow) &&
  extraGuestSalesEarnings?.length > 0 &&
  extraGuestSalesEarnings.map((extraSale, idx) => {
    const extraSaleValid = extraSale?.sales_commission !== "0.00";

    // if no commission, don't show row
    if (!extraSaleValid) return null;

    // apply date filter (use sales_commission_obtained_date for extra guest earned date)
    if (startDateFilter && endDateFilter) {
      const earnedDate = moment(extraSale?.sales_commission_obtained_date).format("YYYY-MM-DD");
      if (earnedDate < startDateFilter || earnedDate > endDateFilter) {
        return null;
      }
    }

    // Status Filter (Paid / Unpaid / Failed)
    const extraEarningObj = {
      sales_commission_paid: extraSale?.sales_commission_paid,
      stripe_sales_payment_status: null,
      dots_sales_payment_status: extraSale?.dots_sales_payment_status,
    };

    // matchesStatusFilter expects (earning, type)
    if (!matchesStatusFilter(statusFilter, extraEarningObj, "sale")) {
      return null;
    }

    return (
      <tr className="payout-table-items" key={`extra-sale-${idx}`}>
        {/* Store */}
        <td>
          <p>{hostDetails?.product?.store?.name}</p>
        </td>

        {/* Product */}
        <td>
          <p>{hostDetails?.product?.name}</p>
        </td>

        {/* Payout */}
        <td>
          <p>
            <strong>
              {(extraSale?.sales_commission_order_status !== "fulfilled" &&
                !extraSale?.sales_commission_cancellation_date)
                ? "TBD"
                : `$${extraSale?.sales_commission}`}
            </strong>
          </p>
        </td>

        {/* Status */}
        <td>
          <p>{getPaymentStatus(mapExtraSaleToEarning(extraSale), "sale")}</p>
        </td>

        {/* Commission */}
        <td>
          <p>Sales</p>
        </td>

        {/* Result */}
        <td className="table-result">
          <p>
            {demoResult(
              { earning: mapExtraSaleToEarning(extraSale) },
              props?.hostDetails?.schedule,
              "sales"
            )}
          </p>
        </td>


        {/* Duration */}
        <td>
          <p>
            {calculateVideoDuration(
              hostDetails?.started_at,
              hostDetails?.ended_at,
              hostDetails?.members?.[0]?.guest_detail?.attend_meeting,
              hostDetails?.members?.[0]?.guest_detail?.left_meeting,
              `${hostDetails?.schedule?.scheduled_date}T${hostDetails?.schedule?.scheduled_time}`
            )}
          </p>
        </td>

        {/* Guest (Extra Guest Name) */}
        <td>
          <p>{extraSale?.sales_guest?.full_name || "-"}</p>
        </td>

        {/* Earned Date (Extra Guest earned = sales_commission_obtained_date) */}
        <td>
          <p>
            {CalculateDate(mapExtraSaleToEarning(extraSale), "sale earned")}
          </p>
        </td>

        {/* Demo Date */}
        <td>
          <p>{CalculateDate(hostDetails?.schedule, "demo date")}</p>
        </td>

        {/* Paid Date */}
        <td>
          <p>
            {CalculateDate(mapExtraSaleToEarning(extraSale), "sale paid")}
          </p>
        </td>

        {/* Reward Type */}
        <td>
          <p>{getRewardTypeLabel(hostDetails?.host_reward_type)}</p>
        </td>
      </tr>
    );
  })}


    </>
  );
};

export default PayoutAccepted;
